(function (angular, app) {
   "use strict";

   app.modules.ui = {
      name: "app.UI",
      controllers: {
         ui: "GRPUIController"
         , navigation : "gg_NavigationController"
         , login : "gg_LoginController"
         , password : "gg_PasswordController"
         , coursehandicap: "gg_CourseHandicapController"
         , alert: "ggAlertController"
         , checkout: "ggCheckoutController"
         , prepaid: "ggPrepaidController"
      }
      , directives : {
         heading: "ggHeadingDirective"
         , background: "ggBackgroundDirective"
         , footing : "ggFootingDirective"
         , navigation : "ggNavigationDirective"
         , pagetitle : "ggPageTitleDirective"
         , scroller : "ggScrollerDirective"
         , timepicker: "ggTimePickerDirective"
         , datepicker: "ggDatePickerDirective"
         , calendar: "ggCalendarDirective"
         , inlinealert: "ggInlineAlertDirective"
      }
      , services : {
         ui: "gg_UIFactory"
         , alerts: "ggAlertService"
         , branding: "ggBrandingService"
      }
      , features : {
         showHeading : true
         , bodyClass : ""
      }
      , templates: {
         login: {
            templateId: "app/ui/controllers/login.html"
         }
         , password: {
            templateId: "app/ui/controllers/password.html"
         }
         , alert: {
            templateId: "app/ui/controllers/alert.html"
         }
         , courseHandicap: {
            templateId: "app/ui/controllers/coursehandicap.html"
         }
         , checkout: {
            templateId: "app/ui/controllers/checkout.html"
         }
         , prepaid: {
            templateId: "app/ui/controllers/prepaidcode.html"
         }
      }
   };
    
   angular.module(app.modules.ui.name, [
      "ngDialog"
   ]);

}(angular, app));
